import { render, staticRenderFns } from "./RegistrationVietnamese.vue?vue&type=template&id=c1a32b88&scoped=true"
import script from "./RegistrationVietnamese.vue?vue&type=script&lang=js"
export * from "./RegistrationVietnamese.vue?vue&type=script&lang=js"
import style0 from "./RegistrationVietnamese.vue?vue&type=style&index=0&id=c1a32b88&prod&scoped=true&lang=css"
import style1 from "./RegistrationVietnamese.vue?vue&type=style&index=1&id=c1a32b88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a32b88",
  null
  
)

export default component.exports